import store from "../../store/store";
import { singOut } from "../../store/slices/userSlice";

const BASE_URL = process.env.REACT_APP_API_BASE;
//const DEFAULT_TIMEOUT = 15000;

const buildQueryString = (params = {}) => {
  const query = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    const value = params[key];

    if (value === null || value === undefined) return;

    if (value instanceof Date) {
      query.append(key, value.toISOString());
    } else {
      query.append(key, value);
    }
  });

  return query.toString();
};

const GetUserFromStore = () => {
  const state = store.getState();
  return state?.user?.user || null;
};

/**
 const GetCompanyFromStore = () => {
  const state = store.getState();
  return state?.company?.company || null;
};

 */
const request = async ({ controller, method, HTTPMethod, data }) => {
  let url = `${BASE_URL}${controller}/${method}`;

  if (data && HTTPMethod === "GET") {
    const qs = buildQueryString(data);
    if (qs) url += `?${qs}`;
  }

  //const timeout = DEFAULT_TIMEOUT;

  //const controllerAbort = new AbortController();
  //const id = setTimeout(() => controllerAbort.abort(), timeout);

  let reply = { ok: false };

  try {
    const user = GetUserFromStore();
    //const company = GetCompanyFromStore();

    if (user === null) {
      return { ok: false }; // Retornar que ni puede hacer nada porque ni tiene TOKEN? Desloguearlo?
    }
    /*
    if (company === null) {
      return { ok: false }; // Retornar que ni puede hacer nada porque ni tiene TOKEN? Desloguearlo?
    }
*/

    const token = user.token;

    let httpObject = {
      method: HTTPMethod,
      //signal: controllerAbort.signal,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    };

    if (HTTPMethod === "POST") {
      httpObject.body = JSON.stringify(data);
    }

    let response = await fetch(url, httpObject);

    //clearTimeout(id);
    if (response !== null) {
      let json = await response.json();
      // token inv�lido
      if (json?.token === false || response.status === 401) {
        // Esto se tiene que validar de otra forma, ya que esa info no deber�a venir ah� o mas bien devolver un status espec�fico cuando eso es porque el token es inv�lido
        store.dispatch(singOut());
        return { ok: false, success: false };
      }

      if (json === undefined || json === null) {
        json = { ok: false };
      } else {
        if (json.ok === undefined || json.ok === null) {
          json.ok = false;
        }
      }

      reply = json;
    } else {
      reply.ok = false;
    }
  } catch (error) {
    console.error("API error:", error);
    reply = { ok: false, success: false };
  }

  return reply;
};

export const connector = {
  get: (controller, method, data) =>
    request({ controller, method: method, HTTPMethod: "GET", data: data }),

  post: (controller, method, data) =>
    request({ controller, method: method, HTTPMethod: "POST", data: data }),
};
